module.exports = __webpack_public_path__ + "img/crowdfunding.659b6ba1.svg";